export default {
  FETCHED_SINGLE: 'FETCHED_MARKET_SETTLEMENT_SUMMARY',
};
